import {type GemSettings} from 'app/utils/config/interface';
import {getErrorMessage} from 'app/utils/error/getErrorMessage';

export const DEFAULT_SITE_LANGUAGE = 'en';

export function getGemSettings() {
    let gemSettings: GemSettings;

    const config = document.getElementById('gem-settings');

    if (!config?.textContent) {
        throw new Error('Gem Settings is missing!');
    }

    try {
        gemSettings = JSON.parse(config.textContent);
    } catch (err) {
        throw new Error(`Can not parse gem settings! ${getErrorMessage(err)}`);
    }

    if (gemSettings && !gemSettings.language) {
        gemSettings.language = DEFAULT_SITE_LANGUAGE;
    }

    return gemSettings;
}

export const getConfigElement = (element: Element): HTMLScriptElement => {
    const configElement = element.nextElementSibling;
    if (configElement instanceof HTMLScriptElement && configElement.matches('.js-gem-json-config')) {
        return configElement;
    }

    throw new Error('Cannot find configuration');
};

export function getComponentConfiguration<T = unknown>(element: Element): T {
    const textContent = getConfigElement(element).textContent;
    if (!textContent) {
        throw new Error('Missing content in config script tag!');
    }

    try {
        return JSON.parse(textContent) as T;
    } catch (err) {
        const componentName = (element as HTMLElement).dataset.gemModuleName ?? element.tagName;
        throw new Error(`Invalid JSON configuration for component: ${componentName}. Error: ${getErrorMessage(err)}`);
    }
}
